module.exports = __webpack_public_path__ + "img/travel-icon.6a0a9252.svg";